import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactNode } from "react";
import Button from "./Button";

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  children: ReactNode;
  onApprove?: () => void;
  showApprove?: boolean;
  size?: "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl" | "xxxxl" | "super";
  withFixedButton?: boolean;
  buttonText?: string;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, title, children, size = "md", onApprove, showApprove, withFixedButton, buttonText }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    xxl: "max-w-2xl",
    xxxl: "max-w-3xl",
    xxxxl: "max-w-4xl",
    super: "max-w-[90%]",
  };
  return (
    <div className="max-w-x fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-80 p-2">
      <div className={`relative w-full ${sizeClasses[size]} bg-sidebar rounded-md shadow-lg overflow-auto max-h-[80vh]`}>
        <div className="flex justify-between items-center p-4 border-b-inputBg sticky top-0 bg-sidebar z-20">
          {title && <h2 className="text-lg font-semibold">{title}</h2>}
          <div className="flex items-center gap-3">
            {onClose && (
              <button onClick={onClose} className="text-text hover:text-danger parent-animation-on-hover" type="button">
                <FontAwesomeIcon icon={faTimes} size="sm" className="shake-on-hover" />
              </button>
            )}
            {onApprove && showApprove && (
              <button onClick={onApprove} className="text-text hover:text-success parent-animation-on-hover" type="button">
                <FontAwesomeIcon icon={faCheck} size="sm" className="shake-on-hover" />
              </button>
            )}
          </div>
        </div>
        <div className="p-4">{children}</div>
        {withFixedButton && (
          <div className={`flex flex-col sticky bottom-0 w-full`}>
            <Button type="button" variant="info" onClick={onClose}>
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
